import { render, staticRenderFns } from "./PopularSideOrders.vue?vue&type=template&id=871e986c&scoped=true"
import script from "./PopularSideOrders.vue?vue&type=script&lang=js"
export * from "./PopularSideOrders.vue?vue&type=script&lang=js"
import style0 from "./PopularSideOrders.vue?vue&type=style&index=0&id=871e986c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871e986c",
  null
  
)

export default component.exports